import dynamic from 'next/dynamic';

import { ComponentProps } from './InlineEnrollment.types';

export const InlineEnrollmentMGP = dynamic<ComponentProps>(() =>
  import('./InlineEnrollment').then(module => module.InlineEnrollment)
);
